import React from 'react';
import { Link } from 'react-router-dom';
import * as Lucide from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { PATHS, SERVICES } from '../mock';

export default function ServicesGrid({ limit, mode = 'paths' }) {
  // 'paths' mode shows the rebranded "Paths Toward Healing" (used on Home).
  // 'services' mode shows the full detailed service list (used on /services).
  const source = mode === 'paths' ? PATHS : SERVICES;
  const list = limit ? source.slice(0, limit) : source;
  const isPaths = mode === 'paths';

  return (
    <section className="section-pad relative overflow-hidden" style={{ background: 'var(--cream)' }}>
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full opacity-40" style={{ background: 'radial-gradient(circle, rgba(232,165,169,0.35), transparent 70%)' }} />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="text-center mb-12 reveal">
          <div className="eyebrow mb-3">{isPaths ? 'Paths Toward Healing' : 'Services'}</div>
          <h2 className="section-title mb-4">
            {isPaths ? (<>How We Walk <span className="text-[color:var(--dusty-rose)]">Beside You</span></>) : 'How We Can Help'}
          </h2>
          <p className="text-[color:var(--deep-sage)] max-w-xl mx-auto text-lg font-medium">
            {isPaths
              ? 'Not treatments — transformations. Every path meets you where you are.'
              : 'Personalized care for your unique journey.'}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
          {list.map((s, i) => {
            const Icon = Lucide[s.icon] || Lucide.Heart;
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} className="group card-soft lift-card p-7 flex flex-col reveal-scale">
                <div className="w-14 h-14 rounded-2xl serviceCard-icon flex items-center justify-center mb-5 icon-hover">
                  <Icon className="w-6 h-6 text-[color:var(--dusty-rose)]" strokeWidth={1.4} />
                </div>
                <h3 className="font-serif-display text-2xl mb-2 text-[color:var(--deep-sage)] font-bold">{s.title}</h3>
                <p className="text-[15px] text-[color:var(--deep-sage)]/85 leading-relaxed flex-1 font-medium">{s.short}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm text-[color:var(--dusty-rose)] font-semibold">
                  {isPaths ? 'Walk this path' : 'Learn more'} <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </Link>
            );
          })}
        </div>

        {limit && (
          <div className="text-center mt-12">
            <Link to="/services" className="btn-primary">View All Services <ArrowRight className="w-4 h-4" /></Link>
          </div>
        )}
      </div>
    </section>
  );
}
